<avi-confirmation
    headerText="{{ l10nKeys.headerText | vtranslate }}"
    (onClose)="dismiss()"
>
    <avi-confirmation_modal-content>
        <p>{{ l10nKeys.alertMessage | vtranslate }}</p>
        <div class="avi-fault-alert-modal__fault-list">
            <div class="avi-fault-alert-modal__fault-list--header">{{ l10nKeys.headerTitle | vtranslate }}</div>
            <ul>
                <li 
                    class="avi-fault-alert-modal__fault-list--items"
                    *ngFor="let result of details; trackBy: trackbyIndex"
                >
                    {{ result }}
                </li>
            </ul>
        </div>
    </avi-confirmation_modal-content>

    <avi-confirmation_modal-actions>
        <cds-button
            class="sel-confirm"
            status="info"
            (click)="dismiss()"
        >
            {{ globalL10nKeys.closeLabel | vtranslate }}
        </cds-button>
    </avi-confirmation_modal-actions>
</avi-confirmation>
